import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import loadable from "@loadable/component";
import stl from "./PostViewCampaign.module.css";
import { useTranslation } from "@i18n";
import { trackEvents } from "../../../../../common/events/events";
var fallback = {
  fallback: "Loading..."
};
var Countdown = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "react-countdown";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "react-countdown" */"react-countdown");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("react-countdown");
    }
    return eval('require.resolve')("react-countdown");
  }
}, fallback);
var CampaignModal = loadable({
  resolved: {},
  chunkName: function chunkName() {
    return "pages-checkout-components-CampaignModal-CampaignModal";
  },
  isReady: function isReady(props) {
    var key = this.resolve(props);
    if (this.resolved[key] !== true) {
      return false;
    }
    if (typeof __webpack_modules__ !== 'undefined') {
      return !!__webpack_modules__[key];
    }
    return false;
  },
  importAsync: function importAsync() {
    return import(/* webpackChunkName: "pages-checkout-components-CampaignModal-CampaignModal" */"@/pages/checkout/components/CampaignModal/CampaignModal");
  },
  requireAsync: function requireAsync(props) {
    var _this = this;
    var key = this.resolve(props);
    this.resolved[key] = false;
    return this.importAsync(props).then(function (resolved) {
      _this.resolved[key] = true;
      return resolved;
    });
  },
  requireSync: function requireSync(props) {
    var id = this.resolve(props);
    if (typeof __webpack_require__ !== 'undefined') {
      return __webpack_require__(id);
    }
    return eval('module.require')(id);
  },
  resolve: function resolve() {
    if (require.resolveWeak) {
      return require.resolveWeak("@/pages/checkout/components/CampaignModal/CampaignModal");
    }
    return eval('require.resolve')("@/pages/checkout/components/CampaignModal/CampaignModal");
  }
}, fallback);
var PostViewCampaign = function PostViewCampaign(props) {
  var _props$newCampaignDat, _props$newCampaignDat4, _props$newCampaignDat5, _props$newCampaignDat6, _props$newCampaignDat7;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(null),
    showCampaignModal = _useState[0],
    setShowCampaignModal = _useState[1];
  var bigGallery = false;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (props === null || props === void 0 ? void 0 : props.newCampaignData) && !bigGallery && /*#__PURE__*/React.createElement("div", {
    className: stl.newCampaignData,
    style: {
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$newCampaignDat = props.newCampaignData) === null || _props$newCampaignDat === void 0 ? void 0 : _props$newCampaignDat.bg_color
    },
    onClick: function onClick() {
      var _props$newCampaignDat2, _props$newCampaignDat3;
      trackEvents("marketing_theme_click", _objectSpread(_objectSpread({}, props.g4_data), {}, {
        has_timer: !!(props !== null && props !== void 0 && (_props$newCampaignDat2 = props.newCampaignData) !== null && _props$newCampaignDat2 !== void 0 && _props$newCampaignDat2.counter_timestamp),
        theme_type: props !== null && props !== void 0 && (_props$newCampaignDat3 = props.newCampaignData) !== null && _props$newCampaignDat3 !== void 0 && _props$newCampaignDat3.finance ? "Finance" : "Cash"
      }));
    }
  }, (props === null || props === void 0 ? void 0 : (_props$newCampaignDat4 = props.newCampaignData) === null || _props$newCampaignDat4 === void 0 ? void 0 : _props$newCampaignDat4.counter_timestamp) && /*#__PURE__*/React.createElement("div", {
    className: stl.counterCotainer
  }, /*#__PURE__*/React.createElement(Countdown, {
    date: (props === null || props === void 0 ? void 0 : (_props$newCampaignDat5 = props.newCampaignData) === null || _props$newCampaignDat5 === void 0 ? void 0 : _props$newCampaignDat5.counter_timestamp) * 1000,
    daysInHours: true,
    onComplete: function onComplete() {},
    renderer: function renderer(_ref) {
      var hours = _ref.hours,
        minutes = _ref.minutes,
        seconds = _ref.seconds,
        days = _ref.days;
      return /*#__PURE__*/React.createElement("div", {
        className: stl.countdown
      }, days > 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, days * 24, " ")) : /*#__PURE__*/React.createElement("strong", null, hours < 10 ? "0".concat(hours) : hours + days * 24), ":", /*#__PURE__*/React.createElement("strong", null, minutes < 10 ? "0".concat(minutes) : minutes), " ", ":", /*#__PURE__*/React.createElement("strong", null, seconds < 10 ? "0".concat(seconds) : seconds));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.campaignText
  }, props === null || props === void 0 ? void 0 : (_props$newCampaignDat6 = props.newCampaignData) === null || _props$newCampaignDat6 === void 0 ? void 0 : _props$newCampaignDat6.text), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setShowCampaignModal(true);
    }
  }, t("اعرف اكثر", {
    ns: "web_post_view"
  }))), showCampaignModal && (props === null || props === void 0 ? void 0 : props.newCampaignData) && !bigGallery && /*#__PURE__*/React.createElement(CampaignModal, {
    isPostModal: true,
    dataFromPost: props === null || props === void 0 ? void 0 : props.newCampaignData,
    modalName: props !== null && props !== void 0 && (_props$newCampaignDat7 = props.newCampaignData) !== null && _props$newCampaignDat7 !== void 0 && _props$newCampaignDat7.finance ? "finance" : "cash",
    doClose: function doClose() {
      return setShowCampaignModal(null);
    }
  }));
};
export default PostViewCampaign;